export default "__VITE_ASSET__C58Ltk4O__"